/* eslint-disable object-curly-newline */
import attributeApi from '@/api/attribute';
import productTypeApi from '@/api/product-type';
import productApi from '@/api/product';
import countryApi from '@/api/country';
import regionApi from '@/api/region';
import {
  storeActionCommit,
} from '@/utils/common-utils';

export default {
  fetchProducerProduct({ commit }, { filters, errorManagementType }) {
    return productApi.fetchProducerProduct(filters, errorManagementType)
      .then((res) => commit('setProducts', {products:res, filters}));
  },
  fetchProducts({ commit }, { filters, errorManagementType }) {
    return productApi.fetchProducts(filters, errorManagementType)
      .then((res) => commit('setProducts', {products:res, filters}));
  },

  fetchProductsBoutique({ commit }, { filters, errorManagementType }) {
    return productApi.fetchProductsBoutique(filters, errorManagementType)
      .then((res) => commit('setProducts', { products: res, filters }));
  },

  fetchProductBoutique({ commit }, { id, idType, errorManagementType }) {
    idType = idType == null ? 'puid' : idType;
    return productApi.fetchProductBoutique(id, idType, errorManagementType)
      .then(storeActionCommit(commit, 'setProduct'));
  },

  fetchProduct({ commit }, { id, idType, errorManagementType }) {
    idType = idType == null ? 'id' : idType;

    return productApi.fetchProduct(id, idType, errorManagementType)
      .then(storeActionCommit(commit, 'setProduct'));
  },
  fetchProductInv({ commit }, { id, idType, errorManagementType }) {
    idType = idType == null ? 'id' : idType;

    return productApi.fetchProductInv(id, idType, errorManagementType)
      .then(storeActionCommit(commit, 'setProductInv'));
  },
  downloadPDF({filters, errorManagementType }) {

    return productApi.downloadPDF(filters, errorManagementType)
    .then((res) => {
      if (res) {
        const url = window.URL.createObjectURL(new Blob([res], { type: 'application/pdf' }));
        return url;
      }
    });
  },

  fetchProductsByPuid({ commit }, { puids, errorManagementType }) {
    return productApi.fetchProductsByPuid(puids, errorManagementType)
      .then((res) => commit('setProducts', { products: res, undefined }));
  },

  fetchProductFilters({ commit }, { errorManagementType }) {
    return Promise.all([
      attributeApi.fetchAttributes('PRODUCT_COLOR', errorManagementType),
      productTypeApi.fetchProductTypes(errorManagementType),
      countryApi.fetchCountries('products', errorManagementType),
      regionApi.fetchRegions(errorManagementType),
    ]).then((result) => {
      commit('setFilters', {
        attributes: result[0],
        productTypes: result[1],
        countries: result[2],
        regions: result[3],
        availability: [],
      });
    });
  },
  fetchCarouselProducts({ commit }, {group, errorManagementType }) {
    return productApi.fetchCarouselProducts( group, errorManagementType)
    .then((res) => {
      commit('setCarouselProducts', {products:res})});
  },
};
